module.exports = __webpack_public_path__ + "static/media/intro_icon_2.05ea2669.svg";